/* eslint-disable max-len */
import React, {useEffect, useRef, useState, useContext, useCallback} from 'react';
import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';
import {useDocumentId, useEngagementId} from '../../../../../../util/customHooks';
import {labels, GetCardTypeForBody, currentResource, isNullOrUndefined} from '../../../../../../util/utils';
import _ from 'lodash';
import {
	getRisks,
	getRiskById,
	relateEstimateToRisk,
	unRelateEstimateToRisk
} from '../../../../../../actions/Risk/riskactions';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import MotifCheckbox from '../../../../BaseComponentWrappers/MotifCheckbox';
import CRABadges from '../../../../CRABadges/CRABadges';
import BodyKnowledgeDescription from '../../BodyKnowledgeDescription';
import {aresTypeEightGuidanceFilter} from '../../../../../Main/Ares/Tasks/TaskView/AresBodies/aresBodyConfig';
import {
	riskCategory,
	riskTypeList,
	constRelateEstimateToRisk,
	Entity,
	promiseAreas
} from '../../../../../../util/uiconstants';
import {useSmartEvidenceSourceId, useSmartEvidenceSourceEntityId} from '../../../../../../util/Ares/customHooks';
import Toast from '../../../../BaseComponentWrappers/MotifToast';
import ProgressBar from '../../../../../Common/BaseComponentWrappers/MotifProgressBar';
import Icon from '../../../../BaseComponentWrappers/MotifIcon';
import {IconoirCustomRiskBolt} from '@ey/motif-react-wrapper/assets/icons/custom';
import AccountExecutionType from '../../../../Accounts/AccountExecutionType/AccountExecutionType';
import ManageRisks from '../../../../RiskFactors/ManageRisks/ManageRisks';
import {getUnresolvedCommentsCount} from '../../../../../../actions/ValidationControl/validationcontrolactions';
import {DocumentTypeIdContext} from '../../../../../Main/Forms/CanvasFormContainer';
import {usePromiseTracker} from 'react-promise-tracker';

export default function RelateEstimateToRisk(props) {
	const {isAresView, bodyContent, headerId, sectionId, bodyId, getBodiesBySectionId, isSnapshotView} = props;

	const dispatch = useDispatch();
	const formBodyBorder = GetCardTypeForBody(bodyContent, isAresView);
	const engagementId = useEngagementId();
	const documentId = useDocumentId();
	const [isLoading, setIsLoading] = useState(false);
	const [relateEstimateToRiskData, setRelateEstimateToRiskData] = useState();
	const smartEvidenceSourceId = useSmartEvidenceSourceId(documentId);
	const smartEvidenceSourceEntityId = useSmartEvidenceSourceEntityId(documentId);
	const documentTypeId = useContext(DocumentTypeIdContext);
	const estimate = useSelector((state) => state?.risk);
	const {promiseInProgress} = usePromiseTracker({area: promiseAreas.RISK_GET_BY_ID_AREA});
	const initialEstimate = useRef(null);

	const [toastConfig, setToastConfig] = useState({
		isToastVisiible: false,
		toastMessage: '',
		toastMessageType: ''
	});

	const resetToastConfig = () => {
		setToastConfig({
			isToastVisiible: false,
			toastMessage: '',
			toastMessageType: ''
		});
	};

	const getValidations = useCallback(() => {
		if (documentId) {
			dispatch(getUnresolvedCommentsCount(engagementId, documentId, documentTypeId));
		}
	}, [engagementId, documentId, documentTypeId]);

	const getEstimate = () => {
		return dispatch(
			getRiskById(
				engagementId,
				smartEvidenceSourceId,
				{includeAccounts: true, includeRelatedRisks: true, includeScots: true},
				{},
				promiseAreas.RISK_GET_BY_ID_AREA
			)
		);
	};

	const getAllRisks = () => {
		return dispatch(
			getRisks(engagementId, {
				riskCategory: riskCategory.risks,
				includeAccounts: true,
				includeScots: true,
				includeRelatedRisks: true
			})
		);
	};

	const getRiskData = (hasLoaders) => {
		let risk123 = [];
		let estimatedRisk4567 = [];

		setIsLoading(hasLoaders);

		if (!promiseInProgress) {
			estimatedRisk4567 = initialEstimate?.current;

			getAllRisks()
				.then((riskData) => {
					risk123 = riskData.data;
					getData(risk123, estimatedRisk4567);
				})
				.finally(() => {
					setIsLoading(false);
					getValidations();
				});
		}
	};

	useEffect(() => {
		const timer = setTimeout(() => {
			resetToastConfig();
		}, 3000);

		return () => clearTimeout(timer);
	}, [toastConfig.isToastVisiible]);

	useEffect(() => {
		if (!isNullOrUndefined(estimate)) {
			initialEstimate.current = estimate;
		}
	}, []);

	useEffect(() => {
		if (!isNullOrUndefined(estimate) && estimate.id === smartEvidenceSourceId) {
			initialEstimate.current = estimate;
			getRiskData(true);
		}
	}, [estimate]);

	const reloadSection = useCallback(() => {
		if (sectionId) {
			getRiskData(false);
		}
	}, [engagementId, documentId, headerId, sectionId, dispatch]);

	function getExecutionTypeLabel(account) {
		if (isNullOrUndefined(account)) {
			return;
		}

		if (!isNullOrUndefined(account.executionTypeID)) {
			const executionTypeBadge = <AccountExecutionType executionTypeId={account?.executionTypeID} />;
			return executionTypeBadge;
		}
	}

	function getData(risk123, estimatedRisk4567) {
		let listRisks = [];

		if (!_.isEmpty(risk123) && !_.isEmpty(estimatedRisk4567)) {
			risk123.forEach((risk) => {
				let listAccounts = [];
				risk?.accounts?.forEach((riskAccount) => {
					let listAssertions = [];
					riskAccount?.assertions?.find((riskAssertion) => {
						estimatedRisk4567?.accounts?.forEach((estAccount) => {
							let assertionObj = estAccount?.assertions?.find(
								(estAssertion) =>
									estAssertion.id === riskAssertion.id && estAssertion.accountId === riskAssertion.accountId
							);
							if (!_.isEmpty(assertionObj)) {
								listAssertions = [...listAssertions, riskAssertion];
							}
						});
					});

					if (!_.isEmpty(listAssertions) && listAssertions.length > 0) {
						listAccounts = [
							...listAccounts,
							{
								accountId: riskAccount.id,
								accountName: riskAccount.accountName,
								hasEstimate: riskAccount.hasEstimate,
								assertions: listAssertions,
								executionTypeID: riskAccount.executionTypeID
							}
						];
					}
				});

				if (!_.isEmpty(listAccounts) && listAccounts.length > 0) {
					let isItRelevant =
						estimatedRisk4567.parentRisks?.filter((parentRisk) => parentRisk.riskId === risk.id).length > 0;

					listRisks = [
						...listRisks,
						{
							parentRiskId: risk.id,
							riskId: estimatedRisk4567.id,
							riskName: risk.riskName,
							isItRelevant: isItRelevant,
							riskTypeId: risk.riskTypeId,
							riskAbbreviation: getRiskTypeAbbreviation(risk.riskTypeId),
							accounts: _.sortBy(listAccounts, constRelateEstimateToRisk.ACCOUNT_NAME),
							isDisabled: false,
							isLoading: false
						}
					];
				}
			});
		}

		if (!_.isEmpty(listRisks) && listRisks.length > 0) {
			const sortedRisks = _.sortBy(listRisks, constRelateEstimateToRisk.RISK_TYPE_ID);
			setRelateEstimateToRiskData(sortedRisks);
		} else {
			setRelateEstimateToRiskData(listRisks);
		}
	}

	const onIconClicked = (e) => {
		e.stopPropagation();
	};

	function getRiskTypeAbbreviation(riskTypeId) {
		return riskTypeList.find((riskType) => riskType.id === riskTypeId)?.abbrev;
	}

	function getAccountAssertionsItems(assertions) {
		if (!_.isEmpty(assertions) && assertions.length > 0) {
			let assertionStatementTypeId = assertions[0].statementTypeId;
			let assertionArray = [];
			let allAssertionsFromResource = currentResource.assertions.filter(
				(assertion) => assertion.statementtypeid == assertionStatementTypeId
			);
			allAssertionsFromResource.forEach((assertionRes) => {
				const assertionObj = assertions.find((assertion) => assertion.knowledgeAssertionId === assertionRes.id);
				if (!_.isEmpty(assertionObj)) {
					assertionArray.push({
						assertionDisplay: (
							<section className="alignassertion">
								<CRABadges
									key={'assertion' + assertionObj.id}
									assertionsId={assertionObj.knowledgeAssertionId}
									craValue={assertionObj.craValue}
									inherentRiskTypeId={assertionObj.inherentRiskTypeId}
									inherentRiskView={true}
									controlRiskTypeId={assertionObj.controlRiskTypeId}
									hasRiskAssociated={assertionObj.hasRiskAssociated}
									assertionName={assertionObj.assertionName}
									assertionAbbreviation={assertionObj.assertionAbbreviation}
								/>
							</section>
						)
					});
				} else {
					assertionArray.push({
						assertionDisplay: (
							<section className="alignassertion">
								<span className="empty-assertion">&nbsp;</span>
							</section>
						)
					});
				}
			});

			return assertionArray;
		}
	}

	function onCheckBoxChange(event, parentRiskId, riskId) {
		setRelateEstimateToRiskData((prevState) =>
			prevState.map((risk) =>
				risk.parentRiskId === parentRiskId
					? {
							...risk,
							isItRelevant: !risk.isItRelevant,
							isDisabled: true,
							isLoading: true
					  }
					: risk
			)
		);

		if (event.currentTarget.checked) {
			const data = {
				parentRiskId: parentRiskId
			};
			dispatch(relateEstimateToRisk(engagementId, riskId, data))
				.then(() => {
					getEstimate().then((estimateData) => {
						initialEstimate.current = estimateData;
					});
				})
				.finally(() => {
					setIsLoading(false);
					setRelateEstimateToRiskData((prevState) =>
						prevState.map((risk) =>
							risk.parentRiskId === parentRiskId ? {...risk, isDisabled: false, isLoading: false} : risk
						)
					);
				});
		} else {
			dispatch(unRelateEstimateToRisk(engagementId, riskId, parentRiskId))
				.then(() => {
					getValidations();
				})
				.finally(() => {
					setIsLoading(false);
					setRelateEstimateToRiskData((prevState) =>
						prevState.map((risk) =>
							risk.parentRiskId === parentRiskId ? {...risk, isDisabled: false, isLoading: false} : risk
						)
					);
				});
		}
		event?.stopPropagation();
	}

	return (
		<Wrapper className={`SectionBodyWrapper ${formBodyBorder}`}>
			<BodyKnowledgeDescription
				onIconClicked={onIconClicked}
				disabled={false}
				showGuidance={false}
				guidanceFilter={aresTypeEightGuidanceFilter}
				isAresView
				isSnapshotView={isSnapshotView}
				bodyModel={bodyContent}
				engagementId={engagementId}
				documentId={documentId}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={bodyId}
				bodyDescriptionText={bodyContent.name}
				getBodiesBySectionId={getBodiesBySectionId}
				showRelateDocumentsIcon={false}
				showDescription={false}
			/>
			{smartEvidenceSourceId == null ||
			smartEvidenceSourceEntityId == null ||
			smartEvidenceSourceEntityId !== Entity.Estimate ? (
				<section className="norecord">
					<section className="no-records-section motif-body2-default-light">{labels.relateEstimateToRisk.noEstimate}</section>
				</section>
			) : (
				<>
					{toastConfig.isToastVisiible && (
						<StyledMotifToast
							variant={toastConfig.toastMessageType}
							className="toast-banner"
							onClose={() => {
								resetToastConfig();
							}}
							children={toastConfig.toastMessage}
						/>
					)}

					<section>
						<ManageRisks onClose={() => reloadSection()} />
					</section>

					{relateEstimateToRiskData?.length === 0 ? (
						<section className="estimaterisk-wrapper">
							{isLoading && (
								<section className="parentloader">
									<section className="loader">
										<ProgressBar isIndeterminate circle hideLabel />
									</section>
									<section className="greywrapper" />
								</section>
							)}
							<section className="no-records-section motif-body2-default-light">{labels.relateEstimateToRiskNoDataMessage}</section>
						</section>
					) : (
						relateEstimateToRiskData?.map((risk, index) => {
							return (
								<section className="estimaterisk-wrapper">
									{risk.isLoading && (
										<section className="parentloader">
											<section className="loader">
												<ProgressBar isIndeterminate circle hideLabel />
											</section>
											<section className="greywrapper" />
										</section>
									)}
									<section className="estimaterisk">
										<section className="risktype">
											<section className="title motif-label4-default-regular">
												{labels.relateEstimateToRisk.riskType}
											</section>
											<section className="datavalue RiskRelatedIcon">
												<Icon className="small" size="16" src={IconoirCustomRiskBolt} title={labels.boltIconTitle} />
												<span className="RiskRelatedIconText motif-body2-default-regular">{risk.riskAbbreviation}</span>
											</section>
										</section>
										<section className="risk">
											<section className="title motif-label4-default-regular">
												{labels.relateEstimateToRisk.risk}
											</section>
											<section className="datavalue">
												<EllipsesControl
													ellipsisClass="motif-body1-default-regular"
													content={risk.riskName}
													tooltip={risk.riskName}
													noOfLines={2}
												/>
											</section>
										</section>
										<section className="accounts">
											<section className="title motif-label4-default-regular">
												{labels.relateEstimateToRisk.accounts}
											</section>
											<section className="datavalue motif-body1-default-regular">
												{risk.accounts !== null ? risk.accounts?.length : 0}
											</section>
										</section>
										<section className="relevance">
											<section className="title motif-label4-default-regular">
												{labels.relateEstimateToRisk.isItRelevant}
											</section>
											<section className="datavalue">
												<MotifCheckbox
													ellipse
													value={risk.isItRelevant}
													onChange={(event) => onCheckBoxChange(event, risk.parentRiskId, risk.riskId)}
													checked={risk.isItRelevant}
													disabled={risk.isDisabled}
												/>
											</section>
										</section>
									</section>
									<section className="account-assertion">
										<section className="header">
											<section className="accountname">
												<section className="accountname motif-label4-default-regular">
													{labels.relateEstimateToRisk.accounts}
												</section>
											</section>
											<section className="hasestimate">
												<section className="estimate title motif-label4-default-regular">
													{labels.relateEstimateToRisk.hasestimate}
												</section>
											</section>
										</section>
										{risk?.accounts?.map((account) => {
											let hasEstimate = account.hasEstimate;
											let assertionArray = getAccountAssertionsItems(account?.assertions);
											return (
												<section className="body">
													<section className="name datavalue">
														<EllipsesControl
															ellipsisClass="motif-body2-default-light"
															content={account.accountName}
															tooltip={account.accountName}
															noOfLines={1}
														/>
													</section>
													<section className="hasestimate">
														{getExecutionTypeLabel(account)}
														{hasEstimate ? (
															<span className="estimate datavalue motif-body2-default-light">{labels.yes}</span>
														) : (
															<span className="estimate datavalue motif-body2-default-light">{labels.no}</span>
														)}
													</section>
												</section>
											);
										})}
									</section>
								</section>
							);
						})
					)}
				</>
			)}
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
	.RiskRelatedIcon {
		display: inline-flex;
		align-items: center;
		cursor: default;
		width: var(--px-40);
		height: var(--px-24);
		margin: 0;
		svg {
			cursor: default;
			width: var(--px-16);
			height: var(--px-16);
			color: var(--neutrals-800);
			path {
				fill: currentColor;
			}
		}
		.RiskRelatedIconText {
			margin-top: calc(var(--px-2) * -1);
			color: var(--neutrals-900);
		}
	}
	.norecord {
		background: var(--neutrals-00white);
		border-radius: var(--px-8);
		border: var(--border-width-small) solid var(--neutrals-200);
		margin-bottom: var(--px-16);
	}
	.no-records-section {
		padding: var(--px-80) var(--px-0);
		display: grid;
		place-items: center;
		color: var(--neutrals-700);
		line-height: var(--px-20);
	}
	.empty-assertion {
		min-width: var(--px-60);
		margin-right: var(--px-10);
		margin-bottom: var(--px-10);
		&:last-child {
			margin-right: 0;
		}
	}
	.estimaterisk-wrapper {
		background: var(--neutrals-00white);
		border-radius: var(--px-8);
		border: var(--border-width-small) solid var(--neutrals-200);
		padding: var(--px-24);
		margin-bottom: var(--px-16);
		position: relative;
		.no-records-section {
			padding: var(--px-80) var(--px-0);
			display: grid;
			place-items: center;
			color: var(--neutrals-700);
			line-height: var(--px-20);
		}
		.parentloader {
			height: 100%;
			position: absolute;
			width: calc(100% - var(--px-48));
			top: 0;
			pointer-events: all;
			z-index: 999;
			.loader {
				width: 100%;
				height: 100%;
				position: relative;
				z-index: 9999;
				top: var(--px-0);
				height: 100%;
				pointer-events: none;
			}
			.motif-progress-bar-wrapper {
				width: 100%;
				position: relative;
				top: 50%;
				transform: translateY(-50%);
			}
			.greywrapper {
				opacity: 0.5;
				position: absolute;
				pointer-events: none;
				width: 100%;
				z-index: 999;
				background: var(--neutrals-00white);
				height: 100%;
				top: 0;
				pointer-events: none;
			}
		}

		.title {
			color: var(--neutrals-500);
			margin-bottom: var(--spacing-x-small);
		}

		.account-assertion {
			padding-top: var(--spacing-medium);
			.header {
				width: 100%;
				display: flex;
				margin-bottom: var(--px-6);
			}
			.body {
				width: 100%;
				display: flex;
				padding: var(--spacing-small) 0;
				border-bottom: var(--border-width-small) solid var(--neutrals-200);
				&:last-child {
					border-bottom: var(--px-0);
				}
			}

			.hasestimate {
				width: 15%;
				display: flex;
				color: var(--neutrals-900);
			}
			.name.datavalue {
				width: 85%;
				color: var(--neutrals-900);
				.executionTypeLabel {
					margin-left: var(--px-8) !important;
				}
				.ellipses {
					width: auto !important;
					max-width: 100%;
				}
			}
			.estimate.datavalue {
				margin-left: auto;
				margin-right: var(--px-32);
			}
			.assertion.datavalue {
				width: 40%;
				display: flex;
				gap: var(--px-12);
				line-height: normal;
				.alignassertion {
					display: inline-flex;
					.craBadgesWrapper {
						display: block;
					}
				}
			}
			.datavalue {
				font-size: var(--px-14);
				font-weight: 300;
				color: var(--neutrals-900);
				&:last-child {
					padding-bottom: 0;
				}
			}
			.accountname {
				width: 85%;
				.accountname {
					color: var(--neutrals-500);
				}
			}
			.hasestimate {
				width: 15%;
				.estimate {
					margin-left: auto;
					margin-right: var(--px-32);
				}
			}
			.assertiondetail {
				width: 40%;
			}
		}
		.estimaterisk {
			display: flex;
			border-bottom: 1px solid var(--neutrals-200);
			padding-bottom: var(--spacing-medium);
			.datavalue {
				color: var(--neutrals-900);
				.ellipses-multilines {
					width: 80%;
				}
			}
			.risktype {
				margin-right: var(--px-30);
			}
			.risk {
				width: 56%;
				margin-right: var(--px-52);
			}
			.accounts {
				width: 10%;
			}
			.relevance {
				width: 12%;
			}
			.accounts {
				margin-right: var(--px-52);
				text-align: right;
			}
			.relevance {
				flex: 1;
				margin-right: var(--px-32);
				text-align: right;
			}
		}
	}
	.to-right {
		justify-content: flex-end;
		flex-wrap: nowrap;
		display: flex;
		font-weight: 700;
		font-size: var(--px-14);
		margin: 0 var(--px-5) var(--px-16) 0;
		.motif-tooltip-wrapper {
			.motif-tooltip-trigger-wrap {
				cursor: pointer;
			}
		}
	}
`;

const StyledMotifToast = styled(Toast)`
	&.toast-banner {
		margin-bottom: var(--px-10);
	}
`;
